import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { defaultFacilityImage } from 'config/facility';
import { Image } from 'components/core/Image';

export function FacilityImage({ src, size, lazyLoad = true, ...rest }) {
	const resolvedSrc = src
		? `https://images.selfstorage.com/${size || 'small'}-compress/${src}`
		: defaultFacilityImage;
	const className = classnames('facility-image', {
		'default-facility-image': !src,
	});

	return (
		<Image
			{...rest}
			src={resolvedSrc}
			className={className}
			lazyLoad={lazyLoad}
		/>
	);
}

FacilityImage.propTypes = {
	src: PropTypes.string,
	size: PropTypes.string,
	lazyLoad: PropTypes.bool,
	crossOrigin: PropTypes.string,
};

export default FacilityImage;
